module.exports = __webpack_public_path__ + "img/new_platform.11ef3a21.png";